/**
 * @ignore
 *
 * The reducer functions for our store. We also set the initial state of the store here as well.
 *
 * For info on Redux reducers, see <https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#writing-reducers>.
 */

import {
    SET_USER
} from './actionTypes';


const initialState = {
    user: {},
    isLoggedIn: false
};

const reducers = (state=initialState, action) => {
    switch (action.type) {

        case SET_USER:
            return Object.assign(
                {},
                state,
                {
                    user: action.payload.user,
                    isLoggedIn: action.payload.isLoggedIn
                });

        default:
            break;
    }

    return state;
};

export default reducers;
